import React from 'react';
import PropTypes from 'prop-types';

import 'src/components/SlideImage.scss';


const getImages = imgs => imgs.map(({ url, density }) => `${url} ${density}x`).join(', ');


const SlideImage = ({ imgUrl, altText }) => (
  <img
    alt={ altText }
    src={ imgUrl[0].url }
    srcSet={ getImages(imgUrl) }
    styleName="slide-img"
  />
);

SlideImage.propTypes = {
  altText: PropTypes.string.isRequired,
  imgUrl: PropTypes.arrayOf(Object).isRequired
};

export default SlideImage;
